import loadable from '@loadable/component';

const LoadableReactQueryDevtools = loadable(async () => {
  const { ReactQueryDevtools } = await import('./ReactQueryDevTools');
  return ReactQueryDevtools;
});

export default LoadableReactQueryDevtools;
